import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import styles from "./CategorySlider.module.css";

export default function CategorySlider() {
  const navigate = useNavigate(); // Initialize navigate

  let sliderImages = [
    {
      _id: "custom",
      title: "custom",
      image:
        "https://elza2-deploy.s3.eu-north-1.amazonaws.com/slider/miubrdr4xqkqlxlzzfgy.png",
    },
    {
      _id: "675c41ba713b874acdbe0cf8",
      title: "Mugs",
      image:
        "https://elza2-deploy.s3.eu-north-1.amazonaws.com/slider/unha9g3piv7rkywtndyp.png",
    },
    {
      _id: "66d3831f1bbba06a86ae9232",
      title: "single sticker",
      image:
        "https://elza2-deploy.s3.eu-north-1.amazonaws.com/slider/g1a60kkhunv0uxjf78jg.png",
    },
    {
      _id: "66d47e52fd17975d3c784cfc",
      title: "Keyboard stickers",
      image:
        "https://elza2-deploy.s3.eu-north-1.amazonaws.com/slider/rnbmxb6f2jpkrzrpoez8.png",
    },
  ];

  async function handleNavigate(category) {
    if (category === "custom") {
      navigate(`/custom`);
      return;
    }
    navigate(`/Products?category=${category}`);
  }

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "linear",
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className={styles.sliderContainer}>
      <Slider {...settings}>
        {sliderImages.map((image, index) => (
          <div key={index} className={styles.sliderItem}>
            {image._id !== "DiscountCode" && (
              <button
                className={styles.navigateButton}
                onClick={() => handleNavigate(image._id)}
              >
                View {image.category}
              </button>
            )}
            <img src={image.image} alt={`Slider Image ${index + 1}`} />
          </div>
        ))}
      </Slider>
    </div>
  );
}
